export default __webpack_public_path__ + "static/media/logo_brand_web.c09934eb.svg";